import { encode } from 'uqr';

/** QR code rendu en SVG natif (aucune injection de HTML). */
export function QrCode({
  value,
  label,
  size = 200,
}: {
  value: string;
  label: string;
  size?: number;
}) {
  const { data } = encode(value, { ecc: 'M', border: 2 });
  const modules = data.length;
  return (
    <svg
      role="img"
      aria-label={label}
      viewBox={`0 0 ${String(modules)} ${String(modules)}`}
      width={size}
      height={size}
      shapeRendering="crispEdges"
      className="app-qr"
    >
      <rect width={modules} height={modules} fill="#ffffff" />
      {data.flatMap((row, y) =>
        row.map((dark, x) =>
          dark ? (
            <rect
              key={`${String(x)}-${String(y)}`}
              x={x}
              y={y}
              width={1}
              height={1}
              fill="#0f1b2a"
            />
          ) : null,
        ),
      )}
    </svg>
  );
}
